var visibleFilterContainer = null;

function updateSize() {
  const mediaQuery = window.matchMedia("(max-width: 767px)");
  const isMobileView = mediaQuery.matches;
  console.log(isMobileView);
  if (isMobileView) {
    visibleFilterContainer = document.querySelector(".filters-mobile");
  } else {
    visibleFilterContainer = document.querySelector(".filters-desktop");
  }
}

updateSize();
//window.addEventListener("resize", updateSize);
/* Sort */

function handleSortChange(e) {
  const SORT_KEY = e?.target?.value || "asc";

  const RANK = {
    3: 3,
    2: 2,
    1: 1,
    undefined: 0,
  };

  const list = document.querySelector("#poiList");

  if (SORT_KEY === "rating") {
    [...list.children]
      .sort((a, b) =>
        RANK[a.dataset["rating"]] > RANK[b.dataset["rating"]] ? -1 : 1
      )
      .forEach((node) => list.appendChild(node));
  } else if (SORT_KEY === "desc") {
    [...list.children]
      .sort((a, b) => (a.dataset["title"] > b.dataset["title"] ? -1 : 1))
      .forEach((node) => list.appendChild(node));
  } else if (SORT_KEY === "price") {
    [...list.children]
      .sort((a, b) =>
        RANK[a.dataset["price"]] > RANK[b.dataset["price"]] ? -1 : 1
      )
      .forEach((node) => list.appendChild(node));
  } else {
    // default behavior
    [...list.children]
      .sort((a, b) => (a.dataset["title"] > b.dataset["title"] ? 1 : -1))
      .forEach((node) => list.appendChild(node));
  }
}

/* Tally total checked filters by dropdown name */
function getCheckedCheckboxesFor(name) {
  const checkeds = visibleFilterContainer.querySelectorAll(
    `input[type="checkbox"]:checked.checkbox-item-${name}`
  );
  const values = [];
  checkeds.forEach(function (chkd) {
    values.push(chkd.value);
  });
  return values;
}

/* Uncheck all filters by dropdown name */
function uncheckAllFor(name) {
  const checkeds = visibleFilterContainer.querySelectorAll(
    `input[type="checkbox"]:checked.checkbox-item-${name}`
  );

  checkeds.forEach(function (chkd) {
    chkd.checked = false;
  });
}

/* Format the filters into an array of objects */
function createQuery(primary, secondary) {
  const arr = [];

  if (!primary && !secondary) return arr;
  if (!primary.length && !secondary.length) return arr;

  if (!secondary || !secondary.length) {
    primary.forEach((p) => {
      arr.push({ [p.dataset.checkboxGroup]: p.value });
    });
  }

  if (!primary.length)
    secondary.forEach((s) => {
      arr.push({ [s.dataset.checkboxGroup]: s.value });
    });

  primary.forEach((p) => {
    secondary.forEach((s) => {
      arr.push({
        [p.dataset.checkboxGroup]: p.value,
        [s.dataset.checkboxGroup]: s.value,
      });
    });
  });
  return arr;
}

/* Show total matches (mobile) */
function showTotalFilteredCount(tally) {
  const talliedResults = document.querySelector(`[data-filtered-pois-tally]`);
  talliedResults.dataset["filteredPoisTally"] = tally;
  talliedResults.innerText = tally === 1 ? `1 Result` : `${tally} Results`;
}

/* Filter POIs */
function filterPois() {
  const allCheckedCuisines = visibleFilterContainer.querySelectorAll(
    `input[type="checkbox"]:checked.checkbox-item-cuisine`
  );

  const allCheckedNeighborhoods = visibleFilterContainer.querySelectorAll(
    `input[type="checkbox"]:checked.checkbox-item-neighborhood`
  );

  /* convert the filters to an array of queries */
  const QUERY = createQuery(allCheckedCuisines, allCheckedNeighborhoods);

  let TALLY = 0; // count up filtered POIs

  const pois = document.querySelectorAll(
    `a[data-cuisine-value][data-neighborhood-value]`
  );

  if (pois.length) {
    /* DEFAULT: if no filters, show all POIs */
    if (!QUERY.length) {
      pois.forEach((poi) => {
        return (poi.style.display = "block");
      });

      TALLY = pois.length;
      showTotalFilteredCount(TALLY);

      return;
    }

    /* check each POI against the filter array */
    pois.forEach((poi) => {
      const queryMatches = [];

      QUERY.filter((q) => {
        const hasCuisineFilter = q?.cuisine;
        const hasNeighborhoodFilter = q?.neighborhood;
        const poiCuisine = poi.dataset?.cuisineValue;
        const poiNeighborhood = poi.dataset?.neighborhoodValue;

        if (!!hasCuisineFilter && !hasNeighborhoodFilter && !!poiCuisine) {
          if (poiCuisine === q?.cuisine) {
            queryMatches.push(true);
          }
        }

        if (!hasCuisineFilter && !!hasNeighborhoodFilter && !!poiNeighborhood) {
          if (poiNeighborhood === q?.neighborhood) {
            queryMatches.push(true);
          }
        }

        if (
          !!hasCuisineFilter &&
          !!hasNeighborhoodFilter &&
          !!poiCuisine &&
          !!poiNeighborhood
        ) {
          if (
            poiCuisine === q?.cuisine &&
            poiNeighborhood === q?.neighborhood
          ) {
            queryMatches.push(true);
          }
        } else queryMatches.push(false);
      });

      /* each poi must match at least 1 of the filters */
      const match = queryMatches.some((m) => !!m);

      if (match) {
        poi.style.display = "block";
        TALLY++;
      } else poi.style.display = "none";
    });
  }

  showTotalFilteredCount(TALLY);
}

/* Trigger a 'change' event when "All [filter]" checkbox option is changed programmatically */
function triggerCheckboxEvent(checkbox) {
  const event = document.createEvent("HTMLEvents");
  event.initEvent("change", false, true);
  checkbox.dispatchEvent(event);
}

function listenForClearFilters() {
  /* mobile feature */
  const clearFiltersBtn = document.getElementById("poi-filter-drawer-clear");
  const allOptionCuisine = document.querySelector(`input[name="all-cuisine"]`);
  const allOptionNeighborhood = document.querySelector(
    `input[name="all-neighborhood"]`
  );

  clearFiltersBtn.addEventListener("click", function () {
    uncheckAllFor("cuisine");
    allOptionCuisine.checked = true;
    allOptionCuisine.disabled = true;

    uncheckAllFor("neighborhood");
    allOptionNeighborhood.checked = true;
    allOptionNeighborhood.disabled = true;

    filterPois();
  });
}

const FILTER_N = "neighborhood";
document.addEventListener("DOMContentLoaded", function () {
  const filterCheckboxes = visibleFilterContainer.querySelectorAll(
    `input[type="checkbox"].checkbox-item-${FILTER_N}`
  );

  const allOption = visibleFilterContainer.querySelector(
    `input[name="all-${FILTER_N}"]`
  );

  /* If "all [filter name]" option checked, deselect all other filters */
  allOption.addEventListener("change", function () {
    if (allOption.checked) {
      allOption.disabled = true;
      uncheckAllFor(FILTER_N);
      filterPois();
    }
  });

  filterCheckboxes.forEach((chkbx) => {
    chkbx.addEventListener("change", function (chkbx) {
      /* Get all filters */
      const name = chkbx.name;

      const filtersTally = visibleFilterContainer.querySelector(
        `[data-${FILTER_N}-filters]`
      );
      const totalSelectedFilters = getCheckedCheckboxesFor(FILTER_N);

      filtersTally.dataset[`${FILTER_N}Filters`] = totalSelectedFilters.length;

      /* Keep "all [filter name]" option checked if no filters selected */
      if (totalSelectedFilters.length > 0) {
        allOption.checked = false;
        allOption.disabled = false;
      } else {
        allOption.checked = true;
        allOption.disabled = true;
      }

      triggerCheckboxEvent(allOption, "change");
      filterPois();
    });
  });
});

const FILTER = "cuisine";
document.addEventListener("DOMContentLoaded", function () {
  const filterCheckboxes = visibleFilterContainer.querySelectorAll(
    `input[type="checkbox"].checkbox-item-${FILTER}`
  );

  const allOption = visibleFilterContainer.querySelector(
    `input[name="all-${FILTER}"]`
  );
  /* If "all [filter name]" option checked, deselect all other filters */
  allOption.addEventListener("change", function (e) {
    if (allOption.checked) {
      allOption.disabled = true;
      uncheckAllFor(FILTER);
      filterPois();
    }
  });

  filterCheckboxes.forEach((chkbx) => {
    chkbx.addEventListener("change", function (chkbx) {
      /* Get all filters */
      const name = chkbx.name;
      const filtersTally = visibleFilterContainer.querySelector(
        `[data-${FILTER}-filters]`
      );
      const totalSelectedFilters = getCheckedCheckboxesFor(FILTER);

      filtersTally.dataset[`${FILTER}Filters`] = totalSelectedFilters.length;

      /* Keep "all [filter name]" option checked if no filters selected */
      if (totalSelectedFilters.length > 0) {
        allOption.checked = false;
        allOption.disabled = false;
      } else {
        allOption.checked = true;
        allOption.disabled = true;
      }

      triggerCheckboxEvent(allOption, "change");
      filterPois();
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  listenForClearFilters();

  // Ensure visibleFilterContainer is set for current viewport
  updateSize();

  const sortOption = visibleFilterContainer.querySelector("#sortOptions");
  sortOption.addEventListener("change", handleSortChange);

  // Trigger initial price sort on page load
  handleSortChange({ target: { value: "price" } });
});
